import React from "react";
import { Row, Col, Card, Typography } from "antd";
import {
  DollarOutlined,
  AppstoreOutlined,
  RiseOutlined,
  TeamOutlined
} from "@ant-design/icons";

//import "./DashboardCards.scss";
import "../../../assets/dist/ConsumerProject/Consumer/ConsumerDashboardNewStyle.css"
const { Text } = Typography;

const iconMap = {
  dollar: <DollarOutlined />,
  briefcase: <AppstoreOutlined />,
  trend: <RiseOutlined />,
  users: <TeamOutlined />
};

const DashboardCards = () => {
    const dashboardData = [
  {
    key: "portfolio",
    title: "Total Portfolio Value",
    value: "$847M",
    description: "+12.3% from last quarter",
    icon: "dollar",
    highlight: true
  },
  {
    key: "investments",
    title: "Active Investments",
    value: "24",
    description: "Across 6 asset classes",
    icon: "briefcase"
  },
  {
    key: "irr",
    title: "Avg. IRR",
    value: "+15.7%",
    description: "+2.1% vs benchmark",
    icon: "trend"
  },
  {
    key: "managers",
    title: "Fund Managers",
    value: "18",
    description: "Top-tier partnerships",
    icon: "users"
  }
];


  return (
    <Row gutter={[16, 16]}>
      {dashboardData.map((item) => (
        <Col
          key={item.key}
          xs={24}
          sm={12}
          lg={6}
          className="dashbaordInfoCardColumn"
        >
          <Card className="dashboard-card">
            <div className="card-header">
              <Text className="card-title">{item.title}</Text>
              <span className="card-icon">{iconMap[item.icon]}</span>
            </div>

            <div className="card-value">{item.value}</div>

            <Text className="card-description">
              {item.description}
            </Text>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default DashboardCards;
